<template>
  <div class="container">
    <div class="content_top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>成员介绍</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content_wrapper">
      <!-- 教授 -->
      <div class="role" v-if="professor != ''">教授</div>
      <div class="cardWrap" v-if="professor != ''">
        <div class="member_card" v-for="(p, index) in professor" :key="index">
          <img :src="p.avatar" :alt="p.name" class="avatar" @click="handleDetail(p.id)" style="cursor:pointer" />
          <div class="cardRight">
            <div class="member_name" @click="handleDetail(p.id)" style="cursor:pointer">
              {{ p.name }}
            </div>
            <div class="member_text">{{ p.others }}</div>
          </div>
        </div>
      </div>
      <!-- 副教授 -->
      <div class="role" v-if="fuProfessor != ''">副教授</div>
      <div class="cardWrap" v-if="fuProfessor != ''">
        <div class="member_card" v-for="(f, index) in fuProfessor" :key="index">
          <img :src="f.avatar" :alt="f.name" class="avatar" @click="handleDetail(f.id)" style="cursor:pointer" />
          <div class="cardRight">
            <div class="member_name" @click="handleDetail(f.id)" style="cursor:pointer">
              {{ f.name }}
            </div>
            <div class="member_text">{{ f.others }}</div>
          </div>
        </div>
      </div>
      <!-- 助理教授 -->
      <div class="role" v-if="associateProfessor != ''">讲师</div>
      <div class="cardWrap" v-if="associateProfessor != ''">
        <div class="member_card" v-for="(a, index) in associateProfessor" :key="index">
          <img :src="a.avatar" :alt="a.name" class="avatar" @click="handleDetail(a.id)" style="cursor:pointer" />
          <div class="cardRight">
            <div class="member_name" @click="handleDetail(a.id)" style="cursor:pointer">
              {{ a.name }}
            </div>
            <div class="member_text">{{ a.others }}</div>
          </div>
        </div>
      </div>
      <!-- 博士后 -->
      <div class="role" v-if="postdoctoral != ''">博士后</div>
      <div class="cardWrap" v-if="postdoctoral != ''">
        <div class="member_card" v-for="(a, index) in postdoctoral" :key="index">
          <img :src="a.avatar" :alt="a.name" class="avatar" @click="handleDetail(a.id)" style="cursor:pointer" />
          <div class="cardRight">
            <div class="member_name" @click="handleDetail(a.id)" style="cursor:pointer">
              {{ a.name }}
            </div>
            <div class="member_text">{{ a.others }}</div>
          </div>
        </div>
      </div>
      <!-- 博士生 -->
      <div class="role" v-if="doctoral != ''">博士生</div>
      <div class="cardWrap" v-if="doctoral != ''">
        <div class="member_card" v-for="(a, index) in doctoral" :key="index">
          <img :src="a.avatar" :alt="a.name" class="avatar" @click="handleDetail(a.id)" style="cursor:pointer" />
          <div class="cardRight">
            <div class="member_name" @click="handleDetail(a.id)" style="cursor:pointer">
              {{ a.name }}
            </div>
            <div class="member_text">{{ a.others }}</div>
          </div>
        </div>
      </div>
      <!-- 硕士生 -->
      <div class="role" v-if="master != ''">硕士生</div>
      <div class="cardWrap" v-if="master != ''">
        <div class="member_card" v-for="(a, index) in master" :key="index">
          <img :src="a.avatar" :alt="a.name" class="avatar" @click="handleDetail(a.id)" style="cursor:pointer" />
          <div class="cardRight">
            <div class="member_name" @click="handleDetail(a.id)" style="cursor:pointer">
              {{ a.name }}
            </div>
            <div class="member_text">{{ a.others }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import requests from "@/api/request";

export default {
  name: "MemberListView",
  data() {
    return {
      memberList: [],
      professor: [],
      fuProfessor: [],
      associateProfessor: [],
      postdoctoral: [],
      doctoral: [],
      master: []
    };
  },
  mounted() {
    this.getMemberList();
  },
  methods: {
    // 获取分页数据
    async getMemberList() {
      return requests({
        url: "/member/showAllMembers",
        method: "GET"
      }).then(res => {
        // console.log('getMemberList', res.data);
        let p = res.data.教授;
        let f = res.data.副教授;
        let a = res.data.讲师;
        let h = res.data.博士后;
        let b = res.data.博士生;
        let m = res.data.硕士生;
        p.forEach((item, i) => {
          this.professor.push(p[i]);
        });
        f.forEach((item, i) => {
          this.fuProfessor.push(f[i]);
        });
        a.forEach((item, i) => {
          this.associateProfessor.push(a[i]);
        });
        if (h != null) {
          h.forEach((item, i) => {
            this.postdoctoral.push(a[i]);
          });
        }

        b.forEach((item, i) => {
          this.doctoral.push(b[i]);
        });
        m.forEach((item, i) => {
          this.master.push(m[i]);
        });
        // console.log('this.NewsList',this.NewsList);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },
    // 详情
    handleDetail(memberId) {
      this.$router.push({ name: "memberDetail", query: { memberId: memberId } });
    },
  }
};
</script>
<style scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}

.content_top {
  margin: 20px 0;
}

.content_wrapper {
  justify-content: center;
  padding: 20px 0;
  margin-bottom: 20px;
}

.role {
  color: #63065f;
  text-align: left;
  font-size: 20px;
  margin-bottom: 5px;
}

.cardWrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  min-height: 100px;
  border: #a8a4a4 solid 1px;
  padding: 20px 5%;
  margin-bottom: 20px;
}

.el-breadcrumb ::v-deep .el-breadcrumb__inner:hover {
  color: #63065f;
}

.member_card {
  margin: 10px 0;
  width: 33.3%;
  height: 80px;
  display: flex;
  align-items: center;
}

.member_card .avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: #63065f 1px solid;
}

.cardRight {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-left: 50px;
}

.member_name {
  line-height: 2em;
  font-size: large;
  cursor: pointer;
}

.member_name:hover {
  color: #63065f;
}

.member_text {
  color: #6c6c6c;
}

.pagination {
  margin: 20px 0;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #63065f;
}
</style>
